import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { logout } from '../../store/actionCreators/authentication';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome/index';
import '../../assets/stylesheets/ProfileSlide/OptionRow.scss';
import { openDialog } from "../../store/actionCreators/dialog";
import {quitMemberClubRequest} from "../../store/actionCreators/member";
import config from "../../config/config";


const OptionRow = ({ option, section, params, to }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();

    const handleRowClick = e => {
        if (!!rowSpecialFns[option]) {
            console.log(`call ${option} method`);
            e.preventDefault();
            rowSpecialFns[option]();
        }
    };

    const rowSpecialFns = {
        logOut: () => dispatch(logout()),
        disband: () => {
            dispatch(openDialog(section === 'union' ? 'disbandUnion' : 'disbandClub', params));
        },
        authority: () => dispatch(openDialog('unionAuthority')),
        clubChips: () => {},
        // clubChips: () => dispatch(openDialog('exchange')),
        quit: () => {
            if (section === 'union') {
                dispatch(openDialog('disbandUnion', { ...params, isMember: true, title: 'quitTheUnion' }));
            }
            if (section === 'options') {
                dispatch(openDialog(
                    'quitMemberClub',
                    {
                        realDialog: true,
                        title: 'notification',
                        footer: 'confirm',
                        onConfirm: () => dispatch(quitMemberClubRequest(history)),
                    },
                ));
            }
        },
        termsAndConditions: () => {
            window.open(`${config.TERMS_AND_CONDITIONS_URL}`, "_blank");
        },
        privacyPolicy: () => {
            window.open(`${config.PRIVACY_POLICY_URL}`, "_blank");
        }
    };

    return (
        <div className={`optionRow ${section}`}>
            <Link to={to || option} onClick={e => handleRowClick(e)} >
                <span className={`icon ${option}`} />
                {params && params['clubName'] && <span className={`clubName`}>{params['clubName']}</span>}
                <span className={'title'}>{!params ? t(`${section}.${option}`) : t(`${section}.${option}`, {section1: params[option] || ''})}</span>
                {option === "buyLevel" && params['leftDays'] > 0 &&
                    <span className={`leftDays`}>{t(`${section}.leftDays`, {day: params['leftDays']})}</span>
                }
                <span className={'arrowIcon'}>
                    <FontAwesomeIcon icon={faChevronRight} className="fa chevron-left" />
                </span>
            </Link>
        </div>
    )
};



export default OptionRow;
